<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

      <config-title-hang>
        <span slot="config_title_hang_ele2">已有的设备类型列表</span>
      </config-title-hang>


        <config-hang @click.native="oneDeviceTypeBtnHandle(value.typeName , value.typeId)"
          v-for="(value,index) in serveDeviceTypeListData" :key="index" >
          <img slot="config_hang_ele1" :src="value.iconUrl" alt />
          <span slot="config_hang_ele2">{{value.typeName}}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";

export default {
  data() {
    return {
      serveDeviceTypeListData:[
        //服务器请求到的设备类型列表
      ]
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang

  },
  methods: {
    oneDeviceTypeBtnHandle(title ,typeId) {
      ////一个设备类型按钮被点击了传递一个title和 类型ID过去
      this.$router.push({path:"deviceList" , query:{title:title , typeId:typeId } })
    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    // console.log("created阶段");
    /// 获取当前用户设备类型列表接口，获取数据
    this.$request({
      method: "post",
      url: "/product/findProductTypeList",
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveDeviceTypeListData = res.data.data; ////拿到服务器返回的数据结果

          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style>
</style>